/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { SalesPipelineStage } from "./SalesPipelineStage";
import {
  SalesPipelineStageFromJSON,
  SalesPipelineStageFromJSONTyped,
  SalesPipelineStageToJSON,
  SalesPipelineStageToJSONTyped,
} from "./SalesPipelineStage";
import type { CompanyProblemType } from "./CompanyProblemType";
import {
  CompanyProblemTypeFromJSON,
  CompanyProblemTypeFromJSONTyped,
  CompanyProblemTypeToJSON,
  CompanyProblemTypeToJSONTyped,
} from "./CompanyProblemType";
import type { MarkupStateFilter } from "./MarkupStateFilter";
import {
  MarkupStateFilterFromJSON,
  MarkupStateFilterFromJSONTyped,
  MarkupStateFilterToJSON,
  MarkupStateFilterToJSONTyped,
} from "./MarkupStateFilter";
import type { BookingEngagement } from "./BookingEngagement";
import {
  BookingEngagementFromJSON,
  BookingEngagementFromJSONTyped,
  BookingEngagementToJSON,
  BookingEngagementToJSONTyped,
} from "./BookingEngagement";
import type { SalesCallTypeFilter } from "./SalesCallTypeFilter";
import {
  SalesCallTypeFilterFromJSON,
  SalesCallTypeFilterFromJSONTyped,
  SalesCallTypeFilterToJSON,
  SalesCallTypeFilterToJSONTyped,
} from "./SalesCallTypeFilter";

/**
 *
 * @export
 * @interface ListCompaniesInput
 */
export interface ListCompaniesInput {
  /**
   *
   * @type {Array<string>}
   * @memberof ListCompaniesInput
   */
  locationFilterIdentifiers?: Array<string> | null;
  /**
   *
   * @type {string}
   * @memberof ListCompaniesInput
   */
  quotedStartDate?: string | null;
  /**
   *
   * @type {string}
   * @memberof ListCompaniesInput
   */
  quotedEndDate?: string | null;
  /**
   *
   * @type {string}
   * @memberof ListCompaniesInput
   */
  bookedStartDate?: string | null;
  /**
   *
   * @type {string}
   * @memberof ListCompaniesInput
   */
  bookedEndDate?: string | null;
  /**
   *
   * @type {CompanyProblemType}
   * @memberof ListCompaniesInput
   */
  problemFilter?: CompanyProblemType | null;
  /**
   *
   * @type {SalesPipelineStage}
   * @memberof ListCompaniesInput
   */
  salesPipelineStageFilter?: SalesPipelineStage | null;
  /**
   *
   * @type {number}
   * @memberof ListCompaniesInput
   */
  minEstimatedMonthlyFreightSpend?: number | null;
  /**
   *
   * @type {number}
   * @memberof ListCompaniesInput
   */
  maxEstimatedMonthlyFreightSpend?: number | null;
  /**
   *
   * @type {boolean}
   * @memberof ListCompaniesInput
   */
  isOverdueSalesCall?: boolean | null;
  /**
   *
   * @type {string}
   * @memberof ListCompaniesInput
   */
  salesCallAuthor?: string | null;
  /**
   *
   * @type {string}
   * @memberof ListCompaniesInput
   */
  salesCallStartDate?: string | null;
  /**
   *
   * @type {string}
   * @memberof ListCompaniesInput
   */
  salesCallEndDate?: string | null;
  /**
   *
   * @type {Array<SalesCallTypeFilter>}
   * @memberof ListCompaniesInput
   */
  salesCallTypes?: Array<SalesCallTypeFilter> | null;
  /**
   *
   * @type {string}
   * @memberof ListCompaniesInput
   */
  starredByEmail?: string | null;
  /**
   *
   * @type {MarkupStateFilter}
   * @memberof ListCompaniesInput
   */
  markupState?: MarkupStateFilter | null;
  /**
   *
   * @type {Array<BookingEngagement>}
   * @memberof ListCompaniesInput
   */
  bookingEngagements?: Array<BookingEngagement> | null;
}

/**
 * Check if a given object implements the ListCompaniesInput interface.
 */
export function instanceOfListCompaniesInput(
  value: object,
): value is ListCompaniesInput {
  return true;
}

export function ListCompaniesInputFromJSON(json: any): ListCompaniesInput {
  return ListCompaniesInputFromJSONTyped(json, false);
}

export function ListCompaniesInputFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ListCompaniesInput {
  if (json == null) {
    return json;
  }
  return {
    locationFilterIdentifiers:
      json["locationFilterIdentifiers"] == null
        ? undefined
        : json["locationFilterIdentifiers"],
    quotedStartDate:
      json["quotedStartDate"] == null ? undefined : json["quotedStartDate"],
    quotedEndDate:
      json["quotedEndDate"] == null ? undefined : json["quotedEndDate"],
    bookedStartDate:
      json["bookedStartDate"] == null ? undefined : json["bookedStartDate"],
    bookedEndDate:
      json["bookedEndDate"] == null ? undefined : json["bookedEndDate"],
    problemFilter:
      json["problemFilter"] == null
        ? undefined
        : CompanyProblemTypeFromJSON(json["problemFilter"]),
    salesPipelineStageFilter:
      json["salesPipelineStageFilter"] == null
        ? undefined
        : SalesPipelineStageFromJSON(json["salesPipelineStageFilter"]),
    minEstimatedMonthlyFreightSpend:
      json["minEstimatedMonthlyFreightSpend"] == null
        ? undefined
        : json["minEstimatedMonthlyFreightSpend"],
    maxEstimatedMonthlyFreightSpend:
      json["maxEstimatedMonthlyFreightSpend"] == null
        ? undefined
        : json["maxEstimatedMonthlyFreightSpend"],
    isOverdueSalesCall:
      json["isOverdueSalesCall"] == null
        ? undefined
        : json["isOverdueSalesCall"],
    salesCallAuthor:
      json["salesCallAuthor"] == null ? undefined : json["salesCallAuthor"],
    salesCallStartDate:
      json["salesCallStartDate"] == null
        ? undefined
        : json["salesCallStartDate"],
    salesCallEndDate:
      json["salesCallEndDate"] == null ? undefined : json["salesCallEndDate"],
    salesCallTypes:
      json["salesCallTypes"] == null
        ? undefined
        : (json["salesCallTypes"] as Array<any>).map(
            SalesCallTypeFilterFromJSON,
          ),
    starredByEmail:
      json["starredByEmail"] == null ? undefined : json["starredByEmail"],
    markupState:
      json["markupState"] == null
        ? undefined
        : MarkupStateFilterFromJSON(json["markupState"]),
    bookingEngagements:
      json["bookingEngagements"] == null
        ? undefined
        : (json["bookingEngagements"] as Array<any>).map(
            BookingEngagementFromJSON,
          ),
  };
}

export function ListCompaniesInputToJSON(json: any): ListCompaniesInput {
  return ListCompaniesInputToJSONTyped(json, false);
}

export function ListCompaniesInputToJSONTyped(
  value?: ListCompaniesInput | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    locationFilterIdentifiers: value["locationFilterIdentifiers"],
    quotedStartDate: value["quotedStartDate"],
    quotedEndDate: value["quotedEndDate"],
    bookedStartDate: value["bookedStartDate"],
    bookedEndDate: value["bookedEndDate"],
    problemFilter: CompanyProblemTypeToJSON(value["problemFilter"]),
    salesPipelineStageFilter: SalesPipelineStageToJSON(
      value["salesPipelineStageFilter"],
    ),
    minEstimatedMonthlyFreightSpend: value["minEstimatedMonthlyFreightSpend"],
    maxEstimatedMonthlyFreightSpend: value["maxEstimatedMonthlyFreightSpend"],
    isOverdueSalesCall: value["isOverdueSalesCall"],
    salesCallAuthor: value["salesCallAuthor"],
    salesCallStartDate: value["salesCallStartDate"],
    salesCallEndDate: value["salesCallEndDate"],
    salesCallTypes:
      value["salesCallTypes"] == null
        ? undefined
        : (value["salesCallTypes"] as Array<any>).map(
            SalesCallTypeFilterToJSON,
          ),
    starredByEmail: value["starredByEmail"],
    markupState: MarkupStateFilterToJSON(value["markupState"]),
    bookingEngagements:
      value["bookingEngagements"] == null
        ? undefined
        : (value["bookingEngagements"] as Array<any>).map(
            BookingEngagementToJSON,
          ),
  };
}
